"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusChoices = exports.LegalFormChoices = void 0;
var LegalFormChoices;
(function (LegalFormChoices) {
    LegalFormChoices["SOCIETE_ANONYME"] = "sa";
    LegalFormChoices["SOCIETE_ANONYME_A_REPONSABILITE_LIMITEE"] = "sarl";
    LegalFormChoices["ENTREPRISE_UNIPERSONNELLE_A_REPONSABILITE_LIMITEE"] = "eurl";
    LegalFormChoices["ARTISAN"] = "artisan";
    LegalFormChoices["ENTREPRISE_INDIVIDUEL_A_RESPONSABILITE_LIMITEE"] = "eirl";
    LegalFormChoices["SOCIETE_ACTIONS_SIMPLIFIEE"] = "sas";
    LegalFormChoices["SOCIETE_ACTIONS_SIMPLIFIEE_UNIPERSONNELLE"] = "sasu";
})(LegalFormChoices = exports.LegalFormChoices || (exports.LegalFormChoices = {}));
var StatusChoices;
(function (StatusChoices) {
    StatusChoices["INACTIVE"] = "inactive";
    StatusChoices["PENDING"] = "pending";
    StatusChoices["ACTIVE"] = "active";
})(StatusChoices = exports.StatusChoices || (exports.StatusChoices = {}));
//# sourceMappingURL=company.js.map